module.exports = __webpack_public_path__ + "img/404.9e2b2843.svg";